export type PartnerConfig = {
  id: string;
  shape: "round" | "square";
  logoSrc: string;
  cardSrc: string;
  email: string;
  phone?: string;
  active: boolean;
};

export const PARTNERS: PartnerConfig[] = [
  {
    id: "durruty",
    shape: "round",
    logoSrc: "/images/partners/Durruty-logo-horizontal.png",
    cardSrc: "/images/partners/Durruty-business-card.png",
    email: "t.rey@durruty-materiaux.fr",
    active: true,
  },
  {
    id: "dan",
    shape: "square",
    logoSrc: "/images/partners/dan-logo-horizontal.png",
    cardSrc: "/images/partners/dan-business-card.jpg",
    email: "dan.plomberie64@gmail.com",
    active: true,
  },
  {
    id: "etc",
    shape: "square",
    logoSrc: "/images/partners/etc-logo-vertical.png",
    cardSrc: "/images/partners/etc-business-card.jpg",
    email: "etc6431@gmail.com",
    active: true,
  },
  {
    id: "dubosc",
    shape: "square",
    logoSrc: "/images/partners/Dubosc-logo-goutte.png",
    cardSrc: "/images/partners/Dubosc-business-card-situation.png",
    email: "duboscetfils@orange.fr",
    active: false,
  },
  {
    id: "hiriburu",
    shape: "square",
    logoSrc: "/images/partners/Hiriburu-logo.png",
    cardSrc: "/images/partners/Hiriburu-business-card-situation.png",
    email: "hiriburuzurgintza@gmail.com",
    phone: "06 22 12 69 26",
    active: true,
  },
];
